import React from 'react';
import OrderDetailContainer from "./OrderDetailContainer";
import {connect} from "react-redux";
import OrderDownloadContainer from "./OrderDownloadContainer";
import BackComponent from "../components/BackComponent";

class OrderDetailPage extends React.Component {
    render() {
        return <div>
            <BackComponent/>
            <div className="row no-margin order-detail-page" >
                <div className="col-sm-12 col-md-8 reward-detail">
                    <OrderDetailContainer key={'order_'+this.props.lang} orderId={this.props.match.params.orderId}/>
                </div>
                <div className="col-sm-12 col-md-4 reward-detail-actionpanel">
                    <OrderDownloadContainer orderId={this.props.match.params.orderId}/>
                </div>
            </div>
        </div>;
    }

}


export default connect(
    (state) => {
        return {
            lang: state.language.currentLanguage,
            imageFetchId: state.reward.item ? state.reward.item.imageFetchId : null,
            friendlyName: state.orderDetail.item ? state.orderDetail.item.rewardFriendlyName : ''
        }
    }
)(OrderDetailPage)

